// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Upuść pliki tutaj: PDF, zdjęcia, Excel, CSV lub Word',
  waiting: 'Wysyłanie ruszy po przesłaniu plików.',
  // A PDF's pages on its tile (B37): "PDF · 1.2 MB · 4 pages".
  pages_one: '{{count}} strona',
  pages_few: '{{count}} strony',
  pages_many: '{{count}} stron',
  pages_other: '{{count}} strony',
  problems: {
    type: 'Nie można wysłać tego typu pliku. Wyślij PDF, zdjęcie (JPG, PNG lub HEIC) albo plik Excel, CSV lub Word.',
    size: 'Ponad 20 MB. Plik może mieć maksymalnie 20 MB.',
    empty: 'Ten plik jest pusty.',
    count: 'Maksymalnie 10 plików w jednej wiadomości.',
    upload: 'Przesyłanie zostało przerwane. Spróbuj ponownie.',
  },
};
